import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import {ProjectReferenceAttributeService} from '../../../services/project-reference-attribute.service';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {Mode} from '../../../models/mode';
import {shareReplay, switchMap} from 'rxjs/operators';
import {FormControl, FormGroup, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-prd-attributes',
    templateUrl: './prd-attributes.component.html',
    standalone: false
})
export class PrdAttributesComponent implements OnInit, OnDestroy {
    private projectReferenceAttributeService = inject<ProjectReferenceAttributeService>('ProjectReferenceAttributeService' as any);
    private toast = inject(ToastrService);

    private subscriptions: Subscription[] = [];

    @Input() refId!: number;
    @Input() mode$!: Observable<Mode>;

    refresh$ = new BehaviorSubject<void>(undefined);
    attributes$ = this.refresh$.pipe(
        switchMap(() => this.projectReferenceAttributeService.listAttributes(this.refId)),
        shareReplay({bufferSize: 1, refCount: true})
    );

    form = new UntypedFormGroup({
        coreDataProject: new UntypedFormControl(null),
        surfaceVVO: new UntypedFormControl(null),
        surfaceFacade: new UntypedFormControl(null),
        locationSize: new UntypedFormControl(null),
        buildingLayersAboveGround: new UntypedFormControl(null),
        buildingLayersUnderGround: new UntypedFormControl(null),
        demolitionSize: new UntypedFormControl(null),
        remediateSize: new UntypedFormControl(null),
        readyForConstructionSize: new UntypedFormControl(null),
        readyToLiveSize: new UntypedFormControl(null),
        keyFeatures: new UntypedFormControl(null),
        maintanceContractYears: new UntypedFormControl(null),
        urbanDensity: new UntypedFormControl(null),
        energyLabel: new UntypedFormControl(null),
        riskManagement: new UntypedFormControl(null),

        // ProjectScope attributes
        projectScopeFromMDM: new UntypedFormControl(null),
        totalBuildingObjects: new UntypedFormControl(null),
        surfaceBVO: new UntypedFormControl(null),
        grossVolume: new UntypedFormControl(null),
        surfaceLot: new UntypedFormControl(null),
        unitsForSale: new UntypedFormControl(null),
        unitsForRent: new UntypedFormControl(null),
    });

    ngOnInit(): void {
        this.subscriptions.push(
            this.mode$.subscribe(mode => mode === Mode.Edit ? this.form.enable({emitEvent: false}) : this.form.disable({emitEvent: false})),
            this.attributes$.subscribe(projectReferenceAttributes => {
                this.form.patchValue({
                    ...(projectReferenceAttributes),
                    urbanDensity: projectReferenceAttributes.urbanDensity?.selectedValueId,
                    energyLabel: projectReferenceAttributes.energyLabel?.selectedValueId,
                    riskManagement: projectReferenceAttributes.riskManagement?.selectedValueId,
                }, {emitEvent: false});
            }),
            this.form.valueChanges.subscribe(async (value) => {
                try {
                    await this.projectReferenceAttributeService.saveAttributes(this.refId, {
                        projectReference: this.refId,
                        ...value
                    }).toPromise();
                } catch (e) {
                    console.error('saveAttributes error', e);
                    this.toast.error('Attribuut opslaan mislukt');
                }
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(it => it.unsubscribe());
    }
}
